import { render, staticRenderFns } from "./AlertsSummary.vue?vue&type=template&id=046ab60a&scoped=true&"
import script from "./AlertsSummary.vue?vue&type=script&lang=ts&"
export * from "./AlertsSummary.vue?vue&type=script&lang=ts&"
import style0 from "./AlertsSummary.vue?vue&type=style&index=0&id=046ab60a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046ab60a",
  null
  
)

export default component.exports